export const SWITCH_TO_ANOTHER_GATEWAY_REQUEST = 'SWITCH_TO_ANOTHER_GATEWAY_REQUEST';
export const SWITCH_TO_ANOTHER_GATEWAY = 'SWITCH_TO_ANOTHER_GATEWAY';
export const VALIDATE_SWITCH_GATEWAY_ASSET_REQUEST = 'VALIDATE_SWITCH_GATEWAY_ASSET_REQUEST';
export const VALIDATE_SWITCH_GATEWAY_ASSET = 'VALIDATE_SWITCH_GATEWAY_ASSET';
export const GET_GATEWAY_ASSETS_LIST_REQUEST = 'GET_GATEWAY_ASSETS_LIST_REQUEST';
export const GET_GATEWAY_ASSETS_LIST = 'GET_GATEWAY_ASSETS_LIST';
export const CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE = 'CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE';
export const RESET_SWITCH_GATEWAY_VALIDATION_RESULT = 'RESET_SWITCH_GATEWAY_VALIDATION_RESULT';
export const MOVE_TO_ANOTHER_GATEWAY = 'MOVE_TO_ANOTHER_GATEWAY';
